import axios from '../../../../utils/request';

function GET_DATA(params) {
    return axios.get("/customer/ACustomerSmsSet/index",{  } )
}
function SUBMIT_ADD(params) {
    return  axios.post("/customer/ACustomerSmsSet/setPost",{...params} )
}


export default {
    GET_DATA,
    SUBMIT_ADD,

};